import { render, staticRenderFns } from "./Prepodavaniye.vue?vue&type=template&id=73fc9046&scoped=true&"
import script from "./Prepodavaniye.vue?vue&type=script&lang=js&"
export * from "./Prepodavaniye.vue?vue&type=script&lang=js&"
import style0 from "./Prepodavaniye.vue?vue&type=style&index=0&id=73fc9046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fc9046",
  null
  
)

export default component.exports